import { observerEpicHelper } from 'epics/helpers'
import { Constants as AlgoliaActions } from 'actions/algolia'
import { algoliaEventsApi } from 'apis/algolia'
// TODO - We want a way to pass in Algolia Data from Browse to keep queryID
export const algoliaEventEpic = observerEpicHelper(
  [AlgoliaActions.EVENT],
  async ({ action, observer }): Promise<void> => {
    algoliaEventsApi({
      events: [
        {
          ...action.payload,
        },
      ],
    })
    observer.complete()
  }
)
export default [algoliaEventEpic]
